import React from 'react';

import { FormSubmitButton } from '../../components/Button/PrimaryButton';
import { FormComponent } from '../../components/FormCom/FormComponent';
import { TextInputField } from '../../components/FormCom/FormField';
import useTrackPackages from '../../hooks/TrackPackage/TrackPackage';
import {
  TrackPackageDataType,
  trackPackageInitialValues,
  TrackPackageSchema,
} from '../../model/trackPackage.model';

const TrackPackageForm = () => {
  const { trackPackages, trackPackageloading } = useTrackPackages();
  const onSubmit = async (values: TrackPackageDataType) => {
    console.log(values);
    trackPackages(values.trackingId);
  };

  return (
    <FormComponent
      initialValues={trackPackageInitialValues}
      schema={TrackPackageSchema}
      onSubmit={onSubmit}
    >
      <TextInputField
        label="Enter your Package ID"
        name="trackingId"
        type="text"
        placeholder="#000001"
      />

      <FormSubmitButton
        className="horizontalSubmitBtn"
        type="submit"
        cheveronIcon
        showIcon={trackPackageloading}
      >
        Track your Package
      </FormSubmitButton>
    </FormComponent>
  );
};

export default TrackPackageForm;
